import { glob } from 'glob';

export async function findProjectJsonFiles(cwd: string): Promise<string[]> {
	return (await glob('**/project.json', { cwd })) as string[];
}
